import { AlertMessage, MUIIcon, Spinner } from "../../../../widgets"
import { FC, useState } from "react"
import { IPaymentButtonProps } from "../IPaymentButtonProps"
import { PageLinkHelper } from "../../../../base/helpers"
import clsx from "clsx"
import { getButtonClass } from "../../buttons/helper"
import { toAbsoluteUrl } from "../../../../../helpers"
import { useAuth } from "../../../../../modules/auth"
import { useGetRazorPayHashMutation } from "./services"
import { submitFormRazorpay } from "../../../helpers/razorPay-submit-form"

export const RazorPayButton: FC<IPaymentButtonProps> = ({
    orderNo, enrolmentNo, entity, entityId,
    currency, amount,
    firstName, email, phoneNumber,
    successPage, failedPage,
    disabled, tooltip, style, size, icon, label,
    className, children
}) => {
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
    const [error, setError] = useState<string>()
    const { siteId, user } = useAuth()
    const [getHash] = useGetRazorPayHashMutation()
    const handleOnClick = () => {
        if (!siteId || !user || !amount || !successPage || !failedPage) return;
        setIsSubmitting(true)
        setError('')

        const successPageUrl = PageLinkHelper.getPageLinkUrl(siteId, successPage);
        const failedPageUrl = PageLinkHelper.getPageLinkUrl(siteId, failedPage);

        getHash({
            enrolmentNo,
            orderNo,
            entity,
            entityId,
            currency: currency || "INR",
            amount,
            name: firstName || '',
            email: email || '',
            phoneNumber: phoneNumber || '',
            successPageUrl,
            failedPageUrl,
        })
            .unwrap()
            .then(data => {
                return submitFormRazorpay(data, currency);
            })
            .catch(() => {
                setError('Failed to generate payment request.');
            }).finally(() => {
                setIsSubmitting(false);
            });
    };

    return (
        <>
            <button
                disabled={disabled || isSubmitting || !user || !amount}
                type="button"
                title={tooltip}
                onClick={handleOnClick}
                className={clsx(getButtonClass(style, size, "btn-secondary"), className)}
            >
                <Spinner show={isSubmitting} className="me-1" />
                <img
                    alt="img"
                    className="h-25px"
                    src={toAbsoluteUrl('/media/logos/razorpay.png')}
                />

                {(!isSubmitting && icon) && <MUIIcon iconName={icon} className={clsx({ "me-1": !!label })} />}
                {label && <span>{label}</span>}
                {children}
            </button>
            <AlertMessage type="Error" show={!!error} message={error} />
        </>
    )
}